import molin_9 from '../../assets/images/tra/molin_9.webp';
import MolinHeader from '../../components/MolinHeader';
import '../../styles/common.css'
export default function StreetBlock2() {
    return (
        <div className="relative">
            <MolinHeader></MolinHeader>
            <img src={molin_9} alt="Hero background" className="w-full h-auto" />
        </div>
    )
}